import {SHOWLOADING, HIDELOADING} from './type.js'

const state = {
  showLoading: false
}

const getters = {
  showLoading(state){
    return state.showLoading;
  }
}

const mutations = {
  [SHOWLOADING](state){
    state.showLoading = true;
  },
  [HIDELOADING](state){
    state.showLoading = false;
  }
}

const actions = {
  showloader: ({commit}) => {
    commit(SHOWLOADING);
  },
  hideloader: ({commit}) => {
    commit(HIDELOADING);
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/loading.js